import { FieldStub } from "./_FieldStub";
import type { FieldPrimitiveProps } from "./types";

// STUB — CHG-1167 scaffold. Real impl lands ε CHG-1165 (billing & wallets).
// Contract: specs/_product/field-primitive-registry.md §1 ('currency_picker').
// Doctrine: feedback_field_primitive_components_canonical.md.

export function CurrencyPicker(props: FieldPrimitiveProps<string>) {
  return <FieldStub {...props} fieldType="currency_picker" inputType="text" />;
}
